export const normalizeCpapDeviceNo = (value) => {
  if (value === null || value === undefined) return "";

  const deviceNo = String(value).trim();
  return deviceNo && deviceNo !== "---" ? deviceNo : "";
};

export const resolveCpapDeviceNo = (orderItemDeviceNo, productDeviceNo) =>
  normalizeCpapDeviceNo(orderItemDeviceNo) ||
  normalizeCpapDeviceNo(productDeviceNo);

export const formatCpapSerialWithDeviceNo = (serialNumber, deviceNo) => {
  const serial =
    serialNumber === null || serialNumber === undefined
      ? ""
      : String(serialNumber).trim();
  const normalizedDeviceNo = normalizeCpapDeviceNo(deviceNo);

  if (!normalizedDeviceNo) return serial;
  if (!serial) return `Device No. ${normalizedDeviceNo}`;

  return `${serial} (Device No. ${normalizedDeviceNo})`;
};
